// MapAssetScanner.js - 从地图 JSON 提取用到的图块纹理 key

/**
 * @param {unknown} texture
 * @param {Set<string>} keys
 */
function collectTextureValue(texture, keys) {
    if (!texture) return;

    if (Array.isArray(texture)) {
        texture.forEach((item) => collectTextureValue(item, keys));
        return;
    }

    if (typeof texture === 'string') {
        keys.add(texture);
    }
}

/**
 * @param {Object} element
 * @param {Set<string>} keys
 */
function collectFromMapElement(element, keys) {
    if (!element || typeof element !== 'object') return;

    collectTextureValue(element.texture, keys);
    collectTextureValue(element.textures, keys);

    if (element.road) {
        collectTextureValue(element.road.texture, keys);
    }

    if (element.positions && Array.isArray(element.positions)) {
        element.positions.forEach((pos) => {
            collectTextureValue(pos.texture, keys);
            collectTextureValue(pos.textures, keys);
        });
    }
}

/**
 * 收集地图 JSON 中引用的图块纹理 key（不含 NPC 精灵图等 spritesheet）
 * @param {Object} mapJson
 * @returns {string[]}
 */
export function collectMapTextureKeys(mapJson) {
    const keys = new Set();

    if (!mapJson || typeof mapJson !== 'object') {
        return [];
    }

    if (mapJson.background?.texture) {
        collectTextureValue(mapJson.background.texture, keys);
    }

    ['towns', 'caves', 'buildings', 'tankcenter', 'naturalElements'].forEach((section) => {
        const items = mapJson[section];
        if (Array.isArray(items)) {
            items.forEach((item) => collectFromMapElement(item, keys));
        }
    });

    return [...keys];
}
